/**
 * Session-wide memory of image URLs the browser has already decoded.
 *
 * Mockup images are immutable per key, so once a URL has loaded anywhere on
 * the page (a card, the canvas, a prefetch) every later <img> with the same
 * URL is served from the browser cache and can be treated as loaded
 * immediately. MockupRenderer uses this to show the design layer without
 * waiting for onLoad again, which removes the "blank shirt, then design"
 * flash when cards remount (e.g. switching between the Design and Products
 * steps).
 */
const loadedUrls = new Set<string>();

export function markImageLoaded(url: string): void {
  if (url) loadedUrls.add(url);
}

export function isImageLoaded(url: string): boolean {
  return url !== '' && loadedUrls.has(url);
}

/** Test helper — clears the memory between tests. */
export function resetImageLoadCache(): void {
  loadedUrls.clear();
}
